import {
  ContentPageContainer,
  ContentPageTitle,
  ContentPageWrapper,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { ChartPageProps } from './types';

export * from './types';

export const ChartPage: FC<ChartPageProps> = () => {
  const { translate } = useTranslation();

  return (
    <ContentPageWrapper>
      <ContentPageContainer>
        <ContentPageTitle dangerouslySetInnerHTML={{ __html: translate('chart.title') }} />
        <div dangerouslySetInnerHTML={{ __html: translate('chart.content') }} />
      </ContentPageContainer>
    </ContentPageWrapper>
  );
};
